var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { NumberUtil } from '@reown/appkit-common';
import { AssetUtil, ChainController } from '@reown/appkit-controllers';
import { MathUtil, customElement } from '@reown/appkit-ui';
import '@reown/appkit-ui/wui-flex';
import '@reown/appkit-ui/wui-text';
import styles from './styles.js';
const SCROLL_THRESHOLD = 300;
let W3mPayOptions = class W3mPayOptions extends LitElement {
    constructor() {
        super();
        this.unsubscribe = [];
        this.options = [];
        this.selectedPaymentAsset = null;
    }
    disconnectedCallback() {
        this.unsubscribe.forEach(unsubscribe => unsubscribe());
        this.resizeObserver?.disconnect();
        const optionsEl = this.shadowRoot?.querySelector('.pay-options-container');
        optionsEl?.removeEventListener('scroll', this.handleOptionsListScroll.bind(this));
    }
    firstUpdated() {
        const optionsEl = this.shadowRoot?.querySelector('.pay-options-container');
        if (optionsEl) {
            requestAnimationFrame(this.handleOptionsListScroll.bind(this));
            optionsEl?.addEventListener('scroll', this.handleOptionsListScroll.bind(this));
            this.resizeObserver = new ResizeObserver(() => {
                this.handleOptionsListScroll();
            });
            this.resizeObserver?.observe(optionsEl);
            this.handleOptionsListScroll();
        }
    }
    render() {
        return html `
      <wui-flex flexDirection="column" gap="2" class="pay-options-container">
        ${this.options.map(option => this.payOptionTemplate(option))}
      </wui-flex>
    `;
    }
    payOptionTemplate(paymentAsset) {
        const { network, metadata, asset, amount = '0' } = paymentAsset;
        const allNetworks = ChainController.getAllRequestedCaipNetworks();
        const targetNetwork = allNetworks.find(net => net.caipNetworkId === network);
        const paymentCaipAddress = `${network}:${asset}`;
        const selectedPaymentCaipAddress = `${this.selectedPaymentAsset?.network}:${this.selectedPaymentAsset?.asset}`;
        const isSelected = paymentCaipAddress === selectedPaymentCaipAddress;
        const bigAmount = NumberUtil.bigNumber(amount, { safe: true });
        const hasEnoughBalance = bigAmount.gt(0);
        return html `
      <wui-flex
        alignItems="center"
        justifyContent="space-between"
        gap="2"
        @click=${() => this.onSelect?.(paymentAsset)}
        class="pay-option-container"
      >
        <wui-flex alignItems="center" gap="2">
          <wui-flex class="token-images-container">
            <wui-image
              src=${ifDefined(metadata.logoURI)}
              class="token-image"
              size="3xl"
            ></wui-image>
            <wui-image
              src=${ifDefined(AssetUtil.getNetworkImage(targetNetwork))}
              class="chain-image"
              size="md"
            ></wui-image>
          </wui-flex>

          <wui-flex flexDirection="column" gap="1">
            <wui-text variant="lg-regular" color="primary">${metadata.symbol}</wui-text>
            ${hasEnoughBalance
            ? html `<wui-text variant="sm-regular" color="secondary">
                  ${bigAmount.round(6).toString()} ${metadata.symbol}
                </wui-text>`
            : null}
          </wui-flex>
        </wui-flex>

        ${isSelected
            ? html `<wui-icon name="checkmark" size="md" color="success"></wui-icon>`
            : null}
      </wui-flex>
    `;
    }
    handleOptionsListScroll() {
        const optionsEl = this.shadowRoot?.querySelector('.pay-options-container');
        if (!optionsEl) {
            return;
        }
        const shouldApplyMask = optionsEl.scrollHeight > SCROLL_THRESHOLD;
        if (shouldApplyMask) {
            optionsEl.style.setProperty('--options-mask-image', `linear-gradient(
          to bottom,
          rgba(0, 0, 0, calc(1 - var(--options-scroll--top-opacity))) 0px,
          rgba(200, 200, 200, calc(1 - var(--options-scroll--top-opacity))) 1px,
          black 50px,
          black calc(100% - 50px),
          rgba(155, 155, 155, calc(1 - var(--options-scroll--bottom-opacity))) calc(100% - 1px),
          rgba(0, 0, 0, calc(1 - var(--options-scroll--bottom-opacity))) 100%
        )`);
            optionsEl.style.setProperty('--options-scroll--top-opacity', MathUtil.interpolate([0, 50], [0, 1], optionsEl.scrollTop).toString());
            optionsEl.style.setProperty('--options-scroll--bottom-opacity', MathUtil.interpolate([0, 50], [0, 1], optionsEl.scrollHeight - optionsEl.scrollTop - optionsEl.offsetHeight).toString());
        }
        else {
            optionsEl.style.setProperty('--options-mask-image', 'none');
            optionsEl.style.setProperty('--options-scroll--top-opacity', '0');
            optionsEl.style.setProperty('--options-scroll--bottom-opacity', '0');
        }
    }
};
W3mPayOptions.styles = [styles];
__decorate([
    property({ type: Array })
], W3mPayOptions.prototype, "options", void 0);
__decorate([
    property()
], W3mPayOptions.prototype, "selectedPaymentAsset", void 0);
__decorate([
    property()
], W3mPayOptions.prototype, "onSelect", void 0);
W3mPayOptions = __decorate([
    customElement('w3m-pay-options')
], W3mPayOptions);
export { W3mPayOptions };
//# sourceMappingURL=index.js.map